// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"dooAwbList_wrapper__1W9cM"};